import React from 'react';
export function ProductShowcase() {
  const rowColors = ['bg-blue-700', 'bg-green-700', 'bg-red-700', 'bg-purple-700', 'bg-amber-700', 'bg-teal-700'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-207">
      <div className="max-w-5xl mx-auto text-center" data-id="element-208">
        <div data-id="element-209">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-210">
            <span className="text-xl" data-id="element-211">🌟</span> PROFEPACK
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-brand-accent" data-id="element-212">
            MEGAPACK SOCIALES LISTO
            <br data-id="element-213" />
            PRIMARIA COMPLETA
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-214">
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-215">
              6 tomos organizados por grado. 360 páginas de contenido completo.
              Solucionario incluido en cada tomo. 6 bonos estratégicos. Todo
              listo para usar desde hoy.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-216">
          <div className="grid grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-217">
            {rowColors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-218">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-219">
                  {i + 1}.º
                </span>
              </div>)}
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-accent text-brand-accent px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-220">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-3xl mx-auto mt-12" data-id="element-221">
          {['✅ Por grado', '✅ Con planificación anual lista', '✅ Con solucionario completo', '✅ Con evaluaciones y rúbricas', '✅ Con bonos incluidos'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-accent px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-222">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-223">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}